import { lazy } from 'react';
import type { View } from '@/app/navigation/navigation-state';
import type { ViewRegistry } from '@/app/routing/view-registry';
import { useNavigation } from '@/app/navigation/use-navigation';

const Home = lazy(() => import('@/features/dashboard/components/Home'));

function HomeView() {
  const { actions } = useNavigation();
  return (
    <Home
      onNavigate={(targetView, params) => {
        // Home widgets emit `view: string` because any widget can target any
        // screen. The registry rejects unknown literals at navigation time
        // (Router throws), so narrow at the boundary rather than propagating
        // `string` inward.
        const idParam = params && typeof params.id === 'string' ? params.id : undefined;
        actions.navigate(targetView as View, {
          viewParams: idParam ? { initialOpenRecordId: idParam } : null,
        });
      }}
    />
  );
}

export const homeViews: Partial<ViewRegistry> = {
  home: {
    component: HomeView,
    guard: {},
  },
};
